import React from 'react';
import { DateTime } from 'luxon';
import { NotificationBadge, Typography } from '@one-thd/sui-atomic-components';
import { UNAVAILABLE_IMAGE_URL } from '../../../constants/general';
export var pickupItemImages = function (fulfillmentGroup, updatedAddressData) {
    var _a, _b;
    var cartLineItems = (_b = (_a = updatedAddressData === null || updatedAddressData === void 0 ? void 0 : updatedAddressData.ordersInfo) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.newOrder.lineItems;
    var mappedLineItems = cartLineItems.map(function (cartItem) {
        var _a;
        var fulfillmentGroupLineItem = (_a = fulfillmentGroup.lineItems) === null || _a === void 0 ? void 0 : _a.find(function (groupItem) { return groupItem.lineId === cartItem.lineId; });
        return {
            lineId: cartItem.lineId,
            estStartDeliveryDate: cartItem.estStartDeliveryDate,
            estEndDeliveryDate: cartItem.estEndDeliveryDate,
            currentQuantity: fulfillmentGroupLineItem === null || fulfillmentGroupLineItem === void 0 ? void 0 : fulfillmentGroupLineItem.currentQuantity,
            brandName: fulfillmentGroupLineItem === null || fulfillmentGroupLineItem === void 0 ? void 0 : fulfillmentGroupLineItem.brandName,
            imageUrl: fulfillmentGroupLineItem === null || fulfillmentGroupLineItem === void 0 ? void 0 : fulfillmentGroupLineItem.imageUrl,
        };
    });
    var groupedLineItems = mappedLineItems.reduce(function (acc, item) {
        var key = "".concat(item.estStartDeliveryDate, ":").concat(item.estEndDeliveryDate);
        if (!acc[key]) {
            acc[key] = [];
        }
        acc[key].push(item);
        return acc;
    }, {});
    var sortedGroupedLineItems = Object.entries(groupedLineItems).sort(function (_a, _b) {
        var keyA = _a[0];
        var keyB = _b[0];
        var _c = keyA
            .split(':')
            .map(function (date) { return new Date(date).getTime(); }), startA = _c[0], endA = _c[1];
        var _d = keyB
            .split(':')
            .map(function (date) { return new Date(date).getTime(); }), startB = _d[0], endB = _d[1];
        if (startA === startB) {
            return endA - endB;
        }
        return startA - startB;
    });
    function formatDeliveryDates(estStartDeliveryDate, estEndDeliveryDate) {
        var startDate = DateTime.fromISO(estStartDeliveryDate);
        var endDate = DateTime.fromISO(estEndDeliveryDate);
        if (endDate > startDate) {
            return "".concat(startDate.toFormat('ccc, LLLL dd'), " - ").concat(endDate.toFormat('ccc, LLLL dd'));
        }
        return startDate.toFormat('ccc, LLLL dd');
    }
    return (React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-5 " }, sortedGroupedLineItems.map(function (_a, index) {
        var key = _a[0], items = _a[1];
        var _b = key.split(':'), estStartDeliveryDate = _b[0], estEndDeliveryDate = _b[1];
        return (React.createElement("div", { key: index },
            React.createElement(Typography, null,
                "Estimated Delivery:",
                ' ',
                React.createElement("span", { className: "sui-font-bold", "data-testid": "delivery-date" }, formatDeliveryDates(estStartDeliveryDate, estEndDeliveryDate))),
            React.createElement("div", { className: "sui-flex sui-gap-5 sui-mt-4 sui-flex-wrap", "data-testid": "pickup-item-images" }, items.map(function (item) { return (React.createElement(NotificationBadge, { key: item.lineId, variant: "strong", size: "small", color: "primary", badgeContent: (item === null || item === void 0 ? void 0 : item.currentQuantity) === 1 ? 0 : item === null || item === void 0 ? void 0 : item.currentQuantity },
                React.createElement("img", { src: (item === null || item === void 0 ? void 0 : item.imageUrl) || UNAVAILABLE_IMAGE_URL, height: 48, width: 48, alt: (item === null || item === void 0 ? void 0 : item.brandName) || 'Product Image', className: "sui-max-w-none img-height-fix" }))); }))));
    })));
};
